export default __webpack_public_path__ + "static/media/photo--sm--86.b13bfb4a.jpg";